var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNutriburstStar = function SvgNutriburstStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2D2F36",
    clipPath: "url(#nutriburst-star_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.165.49H8.77v7.977h2.395zM11.165 11.503H8.77v7.977h2.395z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.236 4.341 1.074 6.437l6.977 3.867 1.162-2.095zM11.876 9.676l-1.161 2.095 6.977 3.868 1.161-2.095z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.684 4.328-6.977 3.867 1.161 2.096 6.978-3.868zM8.051 9.673 1.074 13.54l1.162 2.095 6.977-3.867z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nutriburst-star_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .52h20v18.96H0z"
  })))));
};
export default SvgNutriburstStar;